import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useIsNative } from "@/hooks/useIsNative";

/** `/sa` index: native → mobile Command Centre; web → existing element, unchanged. */
export default function SAIndexRoute({ children }: { children: ReactNode }) {
  const isNative = useIsNative();
  if (isNative) return <Navigate to="/sa-mobile" replace />;
  return <>{children}</>;
}
